import { IEditTaPayload, IGetTaList, ITaCreate, ITaDetails, ITaListSearch } from "../../../types/master/taInterface";
import { TaActionTypes, TaActions } from "../../actionTypes/master/taActionTypes";

export const createTa = (payload: ITaCreate): TaActionTypes => ({
  type: TaActions.CREATE_TA,
  payload,
});

export const getTaList = (payload: ITaListSearch): TaActionTypes => ({
  type: TaActions.GET_TA_LIST,
  payload,
});

export const setTaList = (taList: Array<IGetTaList>) : TaActionTypes => ({
  type: TaActions.SET_TA_LIST,
  payload: taList
})

export const setTaListPageCount = (payload:number): TaActionTypes => ({
  type: TaActions.SET_TA_LIST_PAGE_COUNT,
  payload
})

export const getTaDataById = (id: number | string): TaActionTypes => ({
  type: TaActions.GET_TA_DATA_BY_ID,
  payload: id
})

export const setTaDataById = (payload: ITaDetails) => ({
  type: TaActions.SET_TA_DATA_BY_ID,
  payload
})

export const editTa = (payload: IEditTaPayload) => ({
  type: TaActions.EDIT_TA_DATA_BY_ID,
  payload,
});
